document.addEventListener("DOMContentLoaded", function () {
    function isWebView() {
        let userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // iOSアプリ内WebViewの判別
        let isIOSWebView = (/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i).test(userAgent);

        // Androidアプリ内WebViewの判別
        let isAndroidWebView = (/Version\/[\d.]+/i).test(userAgent) && (/Chrome\/[\d.]+/i).test(userAgent);

        return isIOSWebView || isAndroidWebView;
    }

    const elements = document.querySelectorAll('.hide-in-webview');

    if (isWebView()) {
        // WebViewなら完全非表示
        elements.forEach(el => el.style.display = 'none');
    } else {
        // 通常Webならすぐに表示
        elements.forEach(el => {
            el.style.visibility = 'visible';
            el.style.opacity = '1';
        });
    }
});
